export default __webpack_public_path__ + "static/media/videoPlayButton.168e465b.svg";